import { isDebugPanelEnabled } from '@/lib/debug/enabled';
import { useDebugStore } from '@/store/debug.store';
import { randomUUID } from '@/lib/uuid';

const isDev = process.env.NODE_ENV !== 'production';

export interface Logger {
  log: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

function pushLogToDebug(level: 'warn' | 'error', args: unknown[]): void {
  if (!isDebugPanelEnabled()) {
    return;
  }
  const message = args
    .map(a => (typeof a === 'string' ? a : JSON.stringify(a)))
    .join(' ')
    .slice(0, 2048);
  useDebugStore.getState().push({
    type: 'window-error',
    id: randomUUID(),
    timestamp: new Date().toISOString(),
    redacted: true,
    payload: { message: `[logger.${level}] ${message}` },
  });
}

export const logger: Logger = {
  log: (...args) => {
    if (isDev) {
      console.log(...args);
    }
  },
  info: (...args) => {
    if (isDev) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    console.warn(...args);
    pushLogToDebug('warn', args);
  },
  error: (...args) => {
    console.error(...args);
    pushLogToDebug('error', args);
  },
};
